<template>
    <dd-modal
      :visible="visible"
      :show-cancel="true"
      @cancel="$emit('cancel')"
      width="52vw"
      data-dusk="customer-select-document-modal"
    >
        <dd-header-card header="E-mail adres selecteren">

          <div class="flex-row gap-md mt-md" style="align-items: flex-start !important">
            <div class="flex-col gap-md" style="min-width: 220px">
              <dd-button
                  v-for="(categoryName, key) in RecipientCategoryDisplayEnum"
                  :type="categoryState === categoryName ? 'primary' : 'none'"
                  class="width-stretch"
                  :key="key"
                  @click="selectCategory(categoryName)"
                  style="position: relative"
              >
                {{ categoryName }}
                <dd-icon
                    v-if="countSelectedByCategory[categoryName] > 0"
                    icon="mdi mdi-check"
                    size="md"
                    :class="['category-check', categoryState === categoryName ? 'color-white' : 'color-black']"
                    style="display: flex; flex: 1; flex-direction: row; justify-content: flex-end"
                />
              </dd-button>
            </div>

            <div class="flex-stretch flex-col gap-md" style="max-width: calc(100% - 240px)">
              <div
                v-if="categoryState === RecipientCategoryDisplayEnum.AGENCY"
                class="flex-row gap-md tabs-box"
              >
                <dd-button
                  @click="selectSubCategory(agenciesSubEnum.RELATED)"
                  title="Dossier gerelateerd maatschappij(en)"
                  :class="(categorySubState === agenciesSubEnum.RELATED ? 'tabs-tab-button-active' : 'tabs-tab-button-inactive')"
                >
                  Dossier gerelateerd
                </dd-button>
                <dd-button
                  @click="selectSubCategory(agenciesSubEnum.ALL)"
                  title="Alle maatschappij(en)"
                  :class="(categorySubState === agenciesSubEnum.ALL ? 'tabs-tab-button-active' : 'tabs-tab-button-inactive')"
                >
                  Alle
                </dd-button>
              </div>

              <dd-input
                placeholder="Zoeken..."
                v-model="query"
              />

              <div v-if="isSelectedCategoryLoading" class="flex-stretch flex-col gap-xs">
                <div>
                  E-mail adressen ({{ categoryState.toLowerCase() }}) laden ...
                </div>
              </div>

              <div v-else-if="noQueryResults" class="flex-stretch flex-col gap-xs">
                <div>
                  Geen e-mail adres gevonden die aan de zoekopdracht voldoet.
                </div>
              </div>

              <div
                v-else-if="emailsByCategoryState.length"
                class="list-scroll flex-stretch flex-col gap-xs"
                style="max-height: 500px; overflow-y: auto"
              >
                <div
                  v-for="(emailData, emailDataIndex) in emailsByCategoryState"
                  :key="emailDataIndex"
                  class="list-scroll flex-stretch flex-col gap-xs"
                >
                  <div v-if="emailData.categoryName">
                    <h2 class="m-0">{{emailData.categoryName}}</h2>
                    <RecipientRowComponent
                      v-for="(address, index) in emailData.data"
                      :key="'d' + index"
                      :name="address.name"
                      :email="address.email"
                      :selected="isSelected(address)"
                      @click="isSelected(address) ? handleRemoveEmail(address) : handleSelectEmail(address)"
                      class="mb-xs"
                    />
                  </div>
                  <RecipientRowComponent
                    v-else
                    :key="emailDataIndex"
                    :name="emailData.name"
                    :email="emailData.email"
                    :selected="isSelected(emailData)"
                    @click="isSelected(emailData) ? handleRemoveEmail(emailData) : handleSelectEmail(emailData)"
                  />
                </div>
              </div>

              <div v-else class="flex-stretch flex-col gap-xs">
                <div>
                  Geen e-mail adressen gevonden
                </div>
              </div>

            </div>
          </div>

          <div class="mt-md flex-row justify-content-end align-items-center gap-md">
            <div
              v-if="selectedEmailAddresses.length > 0"
              class="flex-row align-items-center justify-content-end gap-sm flex-stretch"
            >
              <dd-icon icon="mdi mdi-check" size="md" class="color-black"/>
              <p class="m-0">{{ selectedEmailAddresses.length }} {{ selectedEmailAddresses.length > 1 ? 'adressen' : 'adres' }} geselecteerd</p>
            </div>
            <dd-button
                type="danger"
                @click="$emit('cancel')"
            >
              Annuleren
            </dd-button>
            <dd-button
              v-if="selectedEmailAddresses.length > 0"
              type="success"
              @click="submitEmails"
            >
              Toevoegen
            </dd-button>
          </div>
        </dd-header-card>
    </dd-modal>
</template>

<script>
import CustomerUtils from '~/util/customer';
import DamageApi from '~/api/damage';
import MortgageApi from '~/api/mortgage';
import UserApi from '~/api/user';
import CustomerApi from '~/api/customer';
import AgencyApi from '~/api/agency';
import OfficeApi from '~/api/office';
import RecipientRowComponent from "./RecipientRowComponent.vue";
import RecipientCategoryEnum from './RecipientCategoryEnum';
import {mapState} from "vuex";

export default {
  name: "SelectRecipientModal",
  emits: ['cancel', 'input'],
  components: {RecipientRowComponent},
  props:{
    customerId:{
      value: [String, Number]
    },
    visible:{
      value: Boolean
    }
  },
  data() {
    return {
      countSelectedByCategory: {},
      categoryState: RecipientCategoryEnum.FAMILY,
      categorySubState: 'all',
      selectedEmailAddresses: [],
      query: '',
      family: undefined,
      users: undefined,
      agencies: undefined,
      relatedAgencies: undefined,
      office: undefined,
      damage: undefined,
      mortgage: undefined,
      loading: {
        customer: false,
        family: false,
        users: false,
        agencies: false,
        relatedAgencies: false,
        office: false,
        damage: false,
        mortgage: false,
      },
      agenciesSubEnum: {
        RELATED: 'related',
        ALL: 'all'
      }
    }
  },
  mounted() {
    this.loadData();

    Object.values(RecipientCategoryEnum).map( value => {
      this.countSelectedByCategory[value] = 0;
    });
  },
  methods:{
    selectCategory(categoryName) {
      this.categoryState = categoryName;
      this.query = '';
    },
    selectSubCategory(categorySubName) {
      this.categorySubState = categorySubName;
      this.query = '';
    },
    isQueried(name) {
      return name.toLowerCase().includes(this.query.toLowerCase());
    },
    isSelected(address) {
      return this.selectedEmailAddresses.find((selectedAddress) => {
        return address.name === selectedAddress.name && address.email === selectedAddress.email;
      });
    },
    countByCategory(category) {
      return this.countSelectedByCategory[category];
    },
    handleSelectEmail(address) {
      this.selectedEmailAddresses.push(address);
      this.countSelectedByCategory[this.categoryState] ++;
    },
    handleRemoveEmail(address) {
      this.selectedEmailAddresses = this.selectedEmailAddresses.filter( selectedAddress => {
        return !(selectedAddress.email === address.email && selectedAddress.name === address.name);
      });
      this.countSelectedByCategory[this.categoryState] --;
    },
    submitEmails() {
      this.$emit('input', this.selectedEmailAddresses.map(selectedAddress => selectedAddress.email));
      this.$emit('cancel');
    },
    async loadData() {
      this.loading.users = true;
      this.loading.agencies = true;

      UserApi.paginateActive(0, 10000)
          .then(({data}) => {
            this.users = data;
          })
          .finally(() => {
            this.loading.users = false
          });

      AgencyApi.paginate(0, 10000)
          .then(({data}) => {
            this.agencies = data;
          })
          .finally(() => {
            this.loading.agencies = false
          });

      if (this.customerId) {
        this.loading.customer = true;
        this.loading.family = true;
        this.loading.relatedAgencies = true;
        this.categorySubState = this.agenciesSubEnum.RELATED;

        CustomerApi.find(this.customerId)
            .then(({data: customer}) => {
              if (customer.office_id) {
                this.loading.office = true;

                OfficeApi.find(customer.office_id)
                    .then(({data}) => {
                      this.office = data;
                    })
                    .finally(() => {
                      this.loading.office = false;
                    });
              }
            })
            .finally(() => {
              this.loading.customer = false;
            });

        CustomerApi.findFamily(this.customerId)
            .then(({data}) => {
              this.family = {};
              if (data.main?.data) this.family.klant = data.main.data;
              if (data.partner?.data) this.family.partner = data.partner.data;
              this.family.children = data.children?.data || [];
            })
            .finally(() => {
              this.loading.family = false;
            });

        AgencyApi.getForFamilyByCustomer(this.customerId)
            .then(({data}) => {
              this.relatedAgencies = data;
            })
            .finally(() => {
              this.loading.relatedAgencies = false;
            });
      }

      if (this.instanceClass && this.instanceId) {
        if (this.instanceClass === 'App\\Models\\Damage') {
          this.loading.damage = true;

          DamageApi.getById(this.instanceId, ['witnesses', 'counterparts', 'garage', 'expert'])
              .then(({data}) => {
                this.damage = data;
              })
              .finally(() => {
                this.loading.damage = false;
              });
        } else if (this.instanceClass === 'App\\Models\\Mortgage') {
          this.loading.mortgage = true;

          MortgageApi.find(this.instanceId, [
            'financier', 'notaris', 'makelaar', 'purchasing_broker', 'taxateur', 'structural_engineer'
          ])
              .then(({data}) => {
                this.mortgage = data;
              })
              .finally(() => {
                this.loading.mortgage = false;
              });
        }
      }
    },
    assembleAddressesFamily() {
      if (!this.family) return [];

      const familyAddresses = [];

      if (this.family.klant?.email_address && this.isQueried(CustomerUtils.getFullName(this.family.klant))) {
        if (this.family.klant.email_address_work !== null) {
          familyAddresses.push({
            categoryName: 'Klant - ' + CustomerUtils.getFullName(this.family.klant),
            data: [{
              name: 'Privé',
              email: this.family.klant.email_address
            },
              {
                name: 'Werk',
                email: this.family.klant.email_address_work
              }]
          })
        } else {
          familyAddresses.push({
            categoryName: 'Klant - ' + CustomerUtils.getFullName(this.family.klant),
            data: [{
              name: 'Privé',
              email: this.family.klant.email_address
            }]
          })
        }
      }

      if (this.family.partner?.email_address && this.isQueried(CustomerUtils.getFullName(this.family.partner))) {
        if (this.family.partner.email_address_work !== null) {
          familyAddresses.push({
            categoryName: 'Partner - ' + CustomerUtils.getFullName(this.family.partner),
            data: [{
              name: 'Privé',
              email: this.family.partner.email_address
            },
              {
                name: 'Werk',
                email: this.family.partner.email_address_work
              }]
          })
        } else {
          familyAddresses.push({
            categoryName: 'Partner - ' + CustomerUtils.getFullName(this.family.partner),
            data: [{
              name: 'Privé',
              email: this.family.partner.email_address
            }]
          })
        }
      }

      const childAddresses = this.family.children.map(child => {
        if (child.email_address && this.isQueried(CustomerUtils.getFullName(child))) {
          return {
            name: CustomerUtils.getFullName(child),
            email: child.email_address
          };
        }
      }).filter(child => child);

      if (childAddresses.length > 0) {
        familyAddresses.push({
          categoryName: 'Kinderen',
          data: childAddresses
        })
      }

      return familyAddresses;
    },
    assembleAddressesAgencies() {
      if (!this.agencies) return [];

      return this.agencies?.map(agency => {
        if (agency.email && this.isQueried(agency.name)) {
          return agency;
        }
      }).filter(data => data);
    },
    assembleCustomerRelatedAddressesAgencies () {
      if (!this.relatedAgencies) return [];

      return this.relatedAgencies?.map(relatedAgency => {
        if (relatedAgency.email && this.isQueried(relatedAgency.name)) {
          return relatedAgency;
        }
      }).filter(data => data);
    },
    assembleAddressesUsers() {
      if (!this.users) return [];

      return this.users?.map(user => {
        if (user.email && this.isQueried(user.fullname)) {
          return {
            name: user.fullname,
            email: user.email
          }
        }
      }).filter(data => data);
    },
    assembleAddressesOffices() {
      if (!this.office) return [];

      return this.isQueried(this.office.name) ? [ this.office ] : [];
    },
    assembleAddressesMortgages() {
      if (!this.mortgage) return [];

      const mortgageEmails = [];

      if (this.mortgage.financier?.data?.email
          && this.isQueried(this.mortgage.financier?.data?.name)
      ) {
        mortgageEmails.push({
          categoryName: 'Geldverstrekker',
          data: [this.mortgage.financier.data]
        });
      }

      // External persons (email: email_address)
      if (this.mortgage.notaris?.data?.email_address
          && this.isQueried(this.mortgage.notaris?.data?.name)
      ) {
        mortgageEmails.push({
          categoryName: 'Notaris',
          data: [{
            name: this.mortgage.notaris.data.name,
            email: this.mortgage.notaris.data.email_address
          }]
        });
      }

      if (this.mortgage.makelaar?.data?.email_address
          && this.isQueried(this.mortgage.makelaar?.data?.name)
      ) {
        mortgageEmails.push({
          categoryName: 'Verkopend makelaar',
          data: [{
            name: this.mortgage.makelaar.data.name,
            email: this.mortgage.makelaar.data.email_address
          }]
        });
      }

      if (this.mortgage.purchasing_broker?.data?.email_address
          && this.isQueried(this.mortgage.purchasing_broker?.data?.name)
      ) {
        mortgageEmails.push({
          categoryName: 'Aankopend makelaar',
          data: [{
            name: this.mortgage.purchasing_broker.data.name,
            email: this.mortgage.purchasing_broker.data.email_address
          }]
        });
      }

      if (this.mortgage.taxateur?.data?.email_address
          && this.isQueried(this.mortgage.taxateur?.data?.name)
      ) {
        mortgageEmails.push({
          categoryName: 'Taxateur',
          data: [{
            name: this.mortgage.taxateur.data.name,
            email: this.mortgage.taxateur.data.email_address
          }]
        });
      }

      if (this.mortgage.structural_engineer?.data?.email_address
          && this.isQueried(this.mortgage.structural_engineer?.data?.name)
      ) {
        mortgageEmails.push({
          categoryName: 'Bouwkundig ingenieur',
          data: [{
            name: this.mortgage.structural_engineer.data.name,
            email: this.mortgage.structural_engineer.data.email_address
          }]
        });
      }

      return mortgageEmails;
    },
    assembleAddressesDamages() {
      if (!this.damage) return [];

      const damageEmails = [];

      if (this.damage.agency_contact
          && this.damage.agency_emailaddress
          && this.isQueried(this.damage.agency_contact)
      ) {
        damageEmails.push({
          categoryName: 'Maatschappij',
          data: [{
            name: this.damage.agency_contact,
            email: this.damage.agency_emailaddress
          }]
        });
      }

      if (this.damage.witnesses?.data) {
        const witnessEmails = this.damage.witnesses?.data.map(witness => {
          if (witness.email && this.isQueried(witness.name)) {
            return witness;
          }
        }).filter(witness => witness);
        if ( witnessEmails.length > 0) damageEmails.push({
          categoryName: 'Getuigen',
          data: witnessEmails
        });
      }

      if (this.damage.counterparts?.data) {
        const counterpartEmails = this.damage.counterparts?.data.map(counterpart => {
          if (counterpart.email && this.isQueried(counterpart.name)) {
            return counterpart;
          }
        }).filter(counterpart => counterpart);

        if (counterpartEmails.length > 0) damageEmails.push({
          categoryName: 'Tegenpartijen',
          data: counterpartEmails
        });
      }

      // External persons (email: email_address)
      if (this.damage.garage?.data?.email_address
          && this.isQueried(this.damage.garage?.data?.name)
      ) {
        damageEmails.push({
          categoryName: 'Garage',
          data: [{
            name: this.damage.garage.data.name,
            email: this.damage.garage.data.email_address
          }]
        });
      }

      if (this.damage.expert?.data?.email_address
          && this.isQueried(this.damage.expert?.data?.name)
      ) {
        damageEmails.push({
          categoryName: 'Expert',
          data: [{
            name: this.damage.expert.data.name,
            email: this.damage.expert.data.email_address
          }]
        });
      }

      return damageEmails;
    },
  },
  computed: {
    ...mapState({
      instance: 'instance',
      category_id: 'category_id',
    }),
    RecipientCategoryDisplayEnum() {
      const recipientCategories = {...RecipientCategoryEnum};

      if ( !this.office ) delete recipientCategories.OFFICE;
      if ( !this.damage ) delete recipientCategories.DAMAGE;
      if ( !this.mortgage ) delete recipientCategories.MORTGAGE;

      return recipientCategories;
    },
    instanceClass() {
      return this.$route.params?.instanceClass || 'customer';
    },
    instanceId() {
      return this.$route.params?.instanceId || this.customerId;
    },
    emailsByCategoryState() {
      if (this.categoryState === RecipientCategoryEnum.FAMILY) {
        return this.assembleAddressesFamily();
      } else if (this.categoryState === RecipientCategoryEnum.AGENCY
          && this.categorySubState === this.agenciesSubEnum.RELATED) {
        return this.assembleCustomerRelatedAddressesAgencies();
      } else if (this.categoryState === RecipientCategoryEnum.AGENCY
          && this.categorySubState === this.agenciesSubEnum.ALL) {
        return this.assembleAddressesAgencies();
      } else if (this.categoryState === RecipientCategoryEnum.USER) {
        return this.assembleAddressesUsers();
      } else if (this.categoryState === RecipientCategoryEnum.OFFICE) {
        return this.assembleAddressesOffices();
      } else if (this.categoryState === RecipientCategoryEnum.MORTGAGE) {
        return this.assembleAddressesMortgages();
      } else if (this.categoryState === RecipientCategoryEnum.DAMAGE) {
        return this.assembleAddressesDamages();
      } else {
        return [];
      }
    },
    noQueryResults() {
      return this.query.length > 0 && !this.emailsByCategoryState.length;
    },
    isSelectedCategoryLoading() {
      switch (this.categoryState) {
        case RecipientCategoryEnum.FAMILY:
          return this.loading.customer || this.loading.family;
        case RecipientCategoryEnum.USER:
          return this.loading.users;
        case RecipientCategoryEnum.AGENCY:
          return this.loading.agencies;
        case RecipientCategoryEnum.OFFICE:
          return this.loading.office;
        case RecipientCategoryEnum.DAMAGE:
          return this.loading.damage;
        case RecipientCategoryEnum.MORTGAGE:
          return this.loading.mortgage;
        default:
          return false;
      }
    }
  },
  watch:{
    visible() {
      this.categoryState = RecipientCategoryEnum.FAMILY;
      this.selectedEmailAddresses = [];

      Object.keys(this.countSelectedByCategory).map( key => {
        this.countSelectedByCategory[key] = 0;
      });

      this.query = '';
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.list-scroll{
  padding-right: $spacing-xxs;
}
.list-scroll::-webkit-scrollbar{
  width: $spacing-xxs;
}
.list-scroll::-webkit-scrollbar-track{
  background-color: #0000;
}
.list-scroll::-webkit-scrollbar-thumb{
  background-color: $color-grey-transparent;
  border-radius: $spacing-xxs;
}
.tabs-box {
  border-bottom: 1px solid lightgrey;
}
.tabs-tab-button-active,
.tabs-tab-button-inactive {
  background-color: white;
  border: none;
  border-radius: 0;
  transition: none !important;
  font-size: 15px !important;
  color: #085fce !important;
  font-weight: 500 !important;
}
.tabs-tab-button-active,
.tabs-tab-button-inactive:hover {
  box-shadow: none !important;
}
.tabs-tab-button-active{
  border-bottom: 2px solid #1890ff;
  text-shadow: 0 0 0.25px #085fce;
}
.tabs-tab-button-inactive{
  border-bottom: none;
}
</style>
